import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import '../styles.less'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import SubProjectBasedItemsWidget from '../../../widgets/projectBasedItemsWidget/SubProjectBasedItemsWidget'
import { getSubprojectPeriodInfo } from '../../../redux/actions/accountingSubProject'

export default function SubProjectBasedItems() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const subProjectCode = sessionGetItemStr('subProjectCode')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSubprojectPeriodInfo(subProjectCode)
      // console.log('getProjectBaseInfo 1234 ', _schema)
      setSchema(_schema.model)
      // setSchema(mockSchema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isIncomeAndExpense>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi isShowGoButton />

        <SubProjectBasedItemsWidget schema={schema} />

        <br />
      </SidebarProposal>
    </div>
  )
}

// const mockSchema = {
//   affectedRows: 5,
//   message: 'Successfully',
//   success: true,
//   didError: false,
//   errorMessage: null,
//   model: {
//     header: 'ข้อมูลโครงการย่อย',
//     subHeader: '',
//     disabled: false,
//     projectInfo: {
//       projectCodeLabel: 'รหัสโครงการหลัก',
//       projectCode: '64-00867',
//       projectNameLabel: 'ชื่อโครงการหลัก',
//       projectName: 'โครงการทดสอบ',
//       subProjectCodeLabel: 'รหัสโครงการย่อย',
//       subProjectCode: '64-00867-01',
//       subProjectNameLabel: 'ชื่อโครงการย่อย',
//       subProjectName: 'โครงการทดสอบ - ย่อย',
//       durationLabel: 'ระยะเวลาดำเนินงาน', // ระยะเวลาดำเนินงาน
//       duration: '1/ม.ค./2564 - 31/ม.ค./2565', // ระยะเวลาดำเนินงาน
//       contractNoLabel: 'เลขที่ข้อตกลง',
//       contractNo: '64-00-0596',
//       coordinatorLabel: 'ผู้ประสานงาน',
//       coordinator: 'ชลการ นักประสาน (สำนัก 6)',
//       responsiblerLebal: 'ผู้รับผิดชอบโครงการ',
//       responsibler: 'สมชาย เก่งกาจ', // ผู้รับผิดชอบโครงการ
//       projectStatusLabel: 'ชื่อโครงการย่อย',
//       projectStatus: 'ดำเนินการ',
//     },
//     period: [
//       {
//         id: '00BC7068-CE35-42C7-8A04-B1FE5E680D7F',
//         periodNo: '1',
//         startAndEndDate: 'วันที่ 1/ม.ค./2564 - 4/เม.ย./2564',
//         budgetOfPeriod: '100,000.00',
//         periodStatusVal: '0',
//         periodStatus: 'นำส่งรายงาน',
//       },
//       {
//         id: '00D87FF2-F27C-4017-ADE0-198AA577EAC8',
//         periodNo: '2',
//         startAndEndDate: 'วันที่ 4/เม.ย./2564 - 1/ส.ค./2564',
//         budgetOfPeriod: '50,000.00',
//         periodStatusVal: '1',
//         periodStatus: 'รับโอนเงินงวด',
//       },
//       {
//         id: '0133F912-3FA3-4A0F-86E6-2818731C1274',
//         periodNo: '3',
//         startAndEndDate: 'วันที่ 1/ส.ค./2564 - 31/ม.ค./2565',
//         budgetOfPeriod: '200,000.00',
//         periodStatusVal: '2',
//         periodStatus: 'ยังไม่รับโอนเงินงวด',
//       },
//     ],
//   },
// }
